// extracted by mini-css-extract-plugin
module.exports = {"action":"Action_action__algDL","action__arrow":"Action_action__arrow___XLdy","action__arrow--up":"Action_action__arrow--up___0pzL"};